import React, {Component} from "react";
import promoterValidator from "../../../helpers/promoterValidator";
import CommonValidator from "../../../helpers/CommonValidator";
import {SUPER_ADMIN, USER_ROLES} from "../../../helpers/constants";
import {Alert, Card, CardBody, CardTitle} from "reactstrap";
import DeleteModal from "../../Common/Modal/DeleteModal";
import {I18n} from "../../../I18n/components/promoter";
import {fetchPromoterCategories} from "../../../actions/promoter/promoterCategoryActions";
import {fetchPromoterSections} from "../../../actions/promoter/promoterSectionActions";
import {closeAlert} from "../../../actions/commonsActions";
import {goBack, push} from "connected-react-router";
import {connect} from "react-redux";
import PromoterVideoList from "./PromoterVideoList";
import PromoterVideoModal from "./PromoterVideoModal";
import {
    fetchPromoterVideos,
    removePromoterVideo,
    saveNewPromoterVideo,
    updateSinglePromoterVideo
} from "../../../actions/promoter/promoterVideoActions";
import PromoterVideoControls from "./PromoterVideoControls";
import swal from "sweetalert";
import {isPromoterPermission} from "../../../helpers/companyService";
import moment from "moment/moment";
import {getCompanyResourceUrl} from "../../../helpers/resourceService";
import filesize from "filesize";

class PromoterVideo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeVideoId: null,
            newVideo: {
                id: null,
                file: null,
                name: null,
                companyId: null,
                categoryIds: [],
                sectionIds: [],
                tags: [],
                playOnFaceDetect: false,
                playbackSettings: null,
            },
            playbackSettings: {
                turnOnTime: null,
                turnOffTime: null,
                minutesBetweenPlays: null,
            },
            companyIdFilter: '',
            categoryIdFilter: '',
            sectionIdFilter: '',
            currentPage: 0,
            modal: false,
            editMode: false,
            isSaveDisable: false,
            isDeleteDisable: false,
        };
        this.validators = promoterValidator(props.lang).videoValidator;
        this.commonValidator = new CommonValidator(this.validators);
    }

    componentDidMount() {
        (async () => {
            const {lang, company, authority} = this.props;

            if (!isPromoterPermission(company, authority)) {
                await swal(I18n[lang].contactUsToAccessThis, '', 'error')
                    .then(() => this.props.goBack())
                return;
            }

            const companyId = authority !== SUPER_ADMIN
                ? company.id
                : null;
            await this.props.fetchCategories({companyId});
            await this.props.fetchSections({companyId});
            await this.fetchPaginatedData(0);
        })();
    }

    isConflictError = response => response && response.status === 409;

    fetchPaginatedData = async currentPage => {
        const {company, authority} = this.props;
        const {companyIdFilter, categoryIdFilter, sectionIdFilter} = this.state;
        await this.props.fetchVideos({
            companyId: authority === SUPER_ADMIN ? companyIdFilter : company.id,
            categoryId: categoryIdFilter,
            sectionId: sectionIdFilter,
            page: currentPage
        });
        await this.fetchThumbnails();
        await this.setState({
            currentPage
        });
    };

    fetchThumbnails = async () => {
        const {promoterVideos} = this.props;
        const secondToCapture = 3;
        const fetchPromises = promoterVideos.map(async video => {
            const url = getCompanyResourceUrl(video.resourceAbacId);
            const thumbnail = await this.getThumbnailForVideo(url, secondToCapture);
            return {videoId: video.id, value: thumbnail};
        })
        await Promise.all(fetchPromises)
            .then(result => this.setState({thumbnails: result}));
    }

    getThumbnailForVideo = async (videoUrl, secondToCapture) => {
        const video = document.createElement("video");
        const canvas = document.createElement("canvas");
        video.style.display = "none";
        canvas.style.display = "none";

        // Trigger video load
        await new Promise((resolve, reject) => {
            video.addEventListener("loadedmetadata", () => {
                video.width = video.videoWidth;
                video.height = video.videoHeight;
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                video.currentTime = secondToCapture;//video.duration * 0.25;
            });
            video.addEventListener("seeked", () => resolve());
            video.addEventListener("error", () => {
                canvas.width = 0;
                resolve();
            });
            video.src = videoUrl;
        });

        this.drawThumbnailForVideo(video, canvas);
        return canvas.toDataURL("image/png");
    }

    drawThumbnailForVideo = (video, canvas) => {
        const context = canvas.getContext("2d");
        if (canvas.width === 0) {
            this.drawBlackRectangle(canvas, context);
            return;
        }
        context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
    }

    drawBlackRectangle = (canvas, context) => {
        canvas.width = 50;
        canvas.height = 75
        context.fillStyle = "#000000";
        context.fillRect(0, 0, 75, 100);
    }

    //region Common
    setCurrentPage = async currentPage => {
        this.setState({
            currentPage
        }, () => {
            this.fetchPaginatedData(currentPage)
        });
    };

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    };

    isOkModalToggle = id => {
        this.setState({
            isOkModal: !this.state.isOkModal,
            activeVideoId: id
        });
    };
    //endregion

    //region Filters
    onCompanyFilterClick = event => {
        this.setState({
            companyIdFilter: event.target.value,
            categoryIdFilter: '',
            sectionIdFilter: ''
        }, () => {
            this.fetchPaginatedData(0);
        });
    }

    onCategoryFilterClick = event => {
        this.setState({
            categoryIdFilter: event.target.value,
            sectionIdFilter: ''
        }, () => {
            this.fetchPaginatedData(0);
        });
    }

    onSectionFilterClick = event => {
        this.setState({
            sectionIdFilter: event.target.value
        }, () => {
            this.fetchPaginatedData(0);
        });
    }

    clearFilters = () => {
        this.setState({
            companyIdFilter: '',
            categoryIdFilter: '',
            sectionIdFilter: '',
        }, () => {
            this.fetchPaginatedData(0);
        })
    };
    //endregion

    onInputChange = event => {
        const name = event.target.name;
        const value = this.getValueFromInputEvent(event);
        this.commonValidator.checkField(name, value);
        this.setState(state => ({
            newVideo: Object.keys(state.newVideo).reduce((res, key) => {
                if (key === name) {
                    res[key] = value;
                } else {
                    res[key] = state.newVideo[key];
                }
                return res
            }, {})
        }));
    };

    getValueFromInputEvent = event => {
        const {target} = event;
        if (target.type === 'checkbox') return target.checked;
        if (event.target.files) return event.target.files[0];
        return event.target.value;
    }

    onPlaybackSettingsChange = (name, value, momentFormat) => {
        this.commonValidator.checkField(name, value);
        this.setState(state => ({
            playbackSettings: Object.keys(state.playbackSettings).reduce((res, key) => {
                if (key === name) {
                    res[key] = moment.isMoment(value)
                        ? value.format(momentFormat)
                        : value;
                } else {
                    res[key] = state.playbackSettings[key];
                }
                return res
            }, {})
        }));
    }

    onCategoriesChange = categories => {
        const allOptions = categories.find(option => Array.isArray(option.value));
        const categoryIds = allOptions
            ? allOptions.value
            : categories.map(c => c.value);

        const sectionIds = this.props.promoterSections
            .filter(s => this.state.newVideo.sectionIds.includes(s.id))
            .filter(s => categoryIds.includes(s.categoryId))
            .map(s => s.id);

        this.setState({
            newVideo: {
                ...this.state.newVideo,
                categoryIds,
                sectionIds,
            },
        });
    }

    onSectionsChange = sections => {
        const allOptions = sections.find(option => Array.isArray(option.value));
        const sectionIds = allOptions
            ? allOptions.value
            : sections.map(s => s.value);

        let {categoryIds} = this.state.newVideo;
        if (!categoryIds || categoryIds.length === 0) {
            categoryIds = this.props.promoterSections
                .filter(s => sectionIds.includes(s.id))
                .map(s => s.categoryId);
        }

        this.setState({
            newVideo: {
                ...this.state.newVideo,
                categoryIds,
                sectionIds,
            },
        });
    }

    onTagsChange = tags => {
        const uniqueTags = [];
        tags.map(tag => {
            if (uniqueTags.indexOf(tag) === -1) {
                uniqueTags.push(tag.toLowerCase())
            }
        });

        this.setState({
            newVideo: {
                ...this.state.newVideo,
                tags: uniqueTags
            },
        });
    }

    clearNewVideoState = async () => {
        const {company, authority} = this.props;
        this.commonValidator.resetAllErrors();
        await this.setState({
            newVideo: {
                id: null,
                file: null,
                name: null,
                companyId: authority !== SUPER_ADMIN ? company.id : null,
                categoryIds: [],
                sectionIds: [],
                playOnFaceDetect: false,
                tags: [],
                playbackSettings: null,
            },
            playbackSettings: {
                turnOnTime: null,
                turnOffTime: null,
                minutesBetweenPlays: null,
            },
            activeVideoId: null,
            editMode: false
        });
    };

    addCategoryClick = () => {
        this.props.changeLocation({
            pathname: '/dashboard/promoter/categories',
            state: {
                modal: true
            }
        })
    }

    addSectionClick = () => {
        this.props.changeLocation({
            pathname: '/dashboard/promoter/sections',
            state: {
                modal: true
            }
        })
    }

    addVideoClick = async () => {
        await this.clearNewVideoState();
        await this.toggle();
    };

    onEditVideo = async (id) => {
        const {promoterVideos} = this.props;
        await this.clearNewVideoState();
        let selectedVideo = promoterVideos.find(item => item.id === id);
        this.setState({
            modal: !this.state.modal,
            editMode: true,
            newVideo: selectedVideo,
        });

        this.initNewVideoCategoryIds();

        if (selectedVideo.playbackSettings) {
            this.setState({
                playbackSettings: selectedVideo.playbackSettings,
            });
        }
    };

    initNewVideoCategoryIds = () => {
        const categoryIds = this.props.promoterSections
            .filter(s => this.state.newVideo.sectionIds.includes(s.id))
            .map(s => s.categoryId);

        this.setState({
            newVideo: {
                ...this.state.newVideo,
                categoryIds,
            },
        });
    }

    deleteVideo = async () => {
        await this.setState({isDeleteDisable: true});
        await this.props.deleteVideo(this.state.activeVideoId);
        await this.fetchPaginatedData(0);
        this.setState({
            isDeleteDisable: false,
            activeVideoId: null
        }, () => this.isOkModalToggle(null))
    };

    handleSubmit = async (event) => {
        const {lang, promoterVideos} = this.props;
        if (event) {
            event.preventDefault();
        }
        if (this.state.playbackSettings !== null && !this.isVideoPlaybackSettingsValid()) {
            await swal(I18n[lang].allOrNonePlaybackSettingsMustBeSpecified, "", "error");
            return;
        }
        await this.addPlaybackSettingsToVideo()

        const {newVideo} = this.state;
        let videos = promoterVideos || [];
        if (this.commonValidator.isValid()) {
            await this.setState({isSaveDisable: true});
            const videoExists = videos.filter(video => video.id === newVideo.id)
                .length > 0;
            const promise = videoExists
                ? this.props.updateVideo(newVideo)
                : this.props.saveVideo(newVideo);
            await promise.then(async () => {
                await this.fetchPaginatedData(0);
                await this.clearNewVideoState();
                await this.toggle();
            }, error => {
                if (this.isConflictError(error)) {
                    swal(I18n[lang].videoAlreadyExists, "", "error")
                }
                console.log(error.statusText);
            })
            await this.setState({isSaveDisable: false});
        }
    };

    isVideoPlaybackSettingsValid = () => {
        const {playbackSettings} = this.state;
        if (!playbackSettings) {
            return true;
        }
        return this.isAllPlaybackSettingsNull() || this.isAllPlaybackSettingsNotNull();
    }

    isAllPlaybackSettingsNull = () => Object.values(this.state.playbackSettings).every(setting => !setting);

    isAllPlaybackSettingsNotNull = () => Object.values(this.state.playbackSettings).every(setting => setting);

    addPlaybackSettingsToVideo = async () => {
        const {newVideo, playbackSettings} = this.state;

        await this.setState({
            newVideo: {
                ...newVideo,
                playbackSettings: this.isAllPlaybackSettingsNotNull() ? playbackSettings : null,
            },
        });
    }

    render() {
        const {
            lang,
            authority,
            companies,
            loading,
            promoterCategories,
            promoterSections,
            promoterVideos,
            pagination
        } = this.props;
        const {
            currentPage,
            isOkModal,
            newVideo,
            playbackSettings,
            modal,
            companyIdFilter,
            categoryIdFilter,
            sectionIdFilter,
            thumbnails
        } = this.state;

        const totalMemoryUsage = promoterVideos.map(v => v.size).reduce((a, b) => a + b, 0);

        const promoterVideoList = loading
            ? <div className="loading">Loading...</div>
            : <PromoterVideoList
                lang={lang}
                companies={companies}
                categories={promoterCategories}
                sections={promoterSections}
                videos={promoterVideos}
                currentPage={currentPage}
                onEditVideo={this.onEditVideo}
                isOkModalToggle={this.isOkModalToggle}
                setCurrentPage={this.setCurrentPage}
                totalPages={pagination.totalPages}
                thumbnails={thumbnails}
            />

        return (
            <div>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                <DeleteModal
                    lang={lang}
                    isOkModal={isOkModal}
                    toggle={this.isOkModalToggle}
                    onDeleteClick={this.deleteVideo}
                    isDeleteDisable={this.state.isDeleteDisable}
                />
                <PromoterVideoModal
                    lang={lang}
                    isModal={modal}
                    toggle={this.toggle}
                    newVideo={newVideo}
                    companies={companies}
                    categories={promoterCategories}
                    sections={promoterSections}
                    handleSubmit={this.handleSubmit}
                    onInputChange={this.onInputChange}
                    playbackSettings={playbackSettings}
                    onPlaybackSettingsChange={this.onPlaybackSettingsChange}
                    validator={this.commonValidator}
                    isSaveDisable={this.state.isSaveDisable}
                    editMode={this.state.editMode}
                    authority={authority}
                    onCategoriesChange={this.onCategoriesChange}
                    onSectionsChange={this.onSectionsChange}
                    onTagsChange={this.onTagsChange}
                />
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-play-circle-outline mr-2"/>
                            {I18n.promoterTitleBeginning + I18n[lang].mediaLibrary}
                        </div>
                    </CardTitle>

                    <CardBody>
                        <PromoterVideoControls
                            lang={lang}
                            onCompanyFilterClick={this.onCompanyFilterClick}
                            onCategoryFilterClick={this.onCategoryFilterClick}
                            onSectionFilterClick={this.onSectionFilterClick}
                            authority={authority}
                            companies={companies}
                            companyId={companyIdFilter}
                            categories={promoterCategories}
                            categoryId={categoryIdFilter}
                            sections={promoterSections}
                            sectionId={sectionIdFilter}
                            clearFilters={this.clearFilters}
                            addCategoryClick={this.addCategoryClick}
                            addSectionClick={this.addSectionClick}
                            addVideoClick={this.addVideoClick}
                            totalMemoryUsage={filesize(totalMemoryUsage)}
                        />
                        {promoterVideoList}
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchCategories: query => dispatch(fetchPromoterCategories(query)),
        fetchSections: query => dispatch(fetchPromoterSections(query)),
        fetchVideos: query => dispatch(fetchPromoterVideos(query)),
        updateVideo: video => dispatch(updateSinglePromoterVideo(video)),
        saveVideo: video => dispatch(saveNewPromoterVideo(video)),
        deleteVideo: videoId => dispatch(removePromoterVideo(videoId)),
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: url => dispatch(push(url)),
        goBack: () => dispatch(goBack()),
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    promoterCategories: state.promoterCategories.promoterCategories,
    promoterSections: state.promoterSections.promoterSections,
    promoterVideos: state.promoterVideos.promoterVideos,
    pagination: state.promoterVideos.pagination,
    loading: state.promoterVideos.loading,
    authority: state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    companies: state.companiesReducer.companies,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(PromoterVideo);


// WEBPACK FOOTER //
// ./src/components/Promoter/PromoterVideo/PromoterVideo.js